var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "MessengerCommentSettings" } }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("messenger.commentSettingsTitle"))),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "description" }, [
        _vm._v(_vm._s(_vm.$t("messenger.commentSettingsDesc"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "body" },
      [_c("CommentManagement", { attrs: { channel: _vm.clone } })],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "form-footer" }, [
      _c(
        "div",
        { staticClass: "actions" },
        [
          _c(
            "a-button",
            {
              staticClass: "pr-confirm-btn",
              attrs: { type: "primary", disabled: _vm.loading },
              on: { click: _vm.handleSave },
            },
            [
              _vm._v(
                "\n                " +
                  _vm._s(_vm.$t("message.update")) +
                  "\n            "
              ),
            ]
          ),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }